import api from "../lib/apiClient";

export const listComplaints = (params = {}) =>
  api.get("/complaints", { params }).then((r) => r.data);

export const getComplaint = (id) =>
  api.get(`/complaints/${id}`).then((r) => r.data);

export const deleteComplaint = (id, reason) =>
  api.delete(`/complaints/${id}`, { data: { reason } }).then((r) => r.data);
